export const min = (items: number[]) => Math.min(...items);
export const max = (items: number[]) => Math.max(...items);
export const average = (items: number[]) => items.reduce((p, c) => p + c, 0) / items.length;
